import React from "react";
import { Box, Button, type ButtonProps, styled, TableCell } from "@mui/material";
import type { CSSObject } from "@mui/material/styles";
import { TOPBARHEIGHT } from "../../../common/constants";
import { Paragraph } from "./Typography";
import type { HeadCell } from "../../../types";

export const AccountWrap = styled(Box)<{ size?: string }>(() => ({
    background: `#ffffff`,
    maxWidth: 1050,
    width: `100%`,
    margin: `${TOPBARHEIGHT + 24}px auto 0`,
}));

export const ModalButtonWrap = styled(Box)(() => ({
    textAlign: `right`,
    marginTop: `auto`,
    "& button": {
        marginLeft: `12px`,
    },
}));

export const ModalBox = styled(Box)<{ size?: string; flexDirection?: React.CSSProperties["flexDirection"] }>(
    ({ size, flexDirection }) => ({
        display: `flex`,
        flexDirection: flexDirection ?? `column`,
        minHeight: size === `small` ? `100%` : `calc(100% - 10px)`,
        padding: `40px 30px 30px`,
        width: `100%`,
        overflow: `auto`,
        maxHeight: `100vh`,
    })
);

export const GradientTop = styled(Box)(({ theme }) => ({
    height: 10,
    width: `100%`,
    background: `linear-gradient(to right,${theme.palette.account.accent},${
        theme.palette.account.accentGradientEnd || `#999`
    })`,
}));

export const SecondaryButton: React.FC<ButtonProps> = ({ children, ...props }) => (
    <Button
        size="small"
        variant="contained"
        sx={{
            border: `none`,
            color: `#333`,
            background: `#FFF`,
            padding: `4px 8px`,
            minWidth: `unset`,
            borderRadius: 2,
            "&:hover": {
                background: `#F5F4F2`,
            },
        }}
        {...props}
    >
        {children}
    </Button>
);

export const EarningBox = styled(Box)<{ box?: string }>(({ box, theme }) => ({
    ...(box === `payout` ? { borderRadius: `16px 0 0 16px` } : { borderRadius: `0 16px  16px 0` }),
    [theme.breakpoints.down(`sm`)]: {
        ...(box === `payout` ? { borderRadius: `16px 16px 0 0` } : { borderRadius: `0 0 16px 16px` }),
    },
    textAlign: `left`,
    display: `flex`,
    flexWrap: `wrap`,
    alignItems: `center`,
    justifyContent: `left`,
    backgroundColor: `#FFF`,
    height: `100%`,
    padding: `24px 24px 16px`,
    border: `1px solid #E1E1E1`,
    minWidth: 275,
}));

// sx is spread into styled callback for override support; cast to CSSObject satisfies the styled return type
export const DollarTitles = styled(Box)<{ sx?: Record<string, unknown> }>(
    ({ sx = {} }) =>
        ({
            fontSize: `35px`,
            fontWeight: 900,
            margin: 0,
            ...sx,
        }) as CSSObject
);

export const LiParagraph = styled(Paragraph)(() => ({
    margin: 0,
}));

// sx is spread into styled callback for override support; cast to CSSObject satisfies the styled return type
export const LiTableCell = styled(TableCell)<{ sx?: Record<string, unknown> }>(
    ({ sx = {} }) =>
        ({
            fontWeight: 600,
            ...sx,
        }) as CSSObject
);

export const shoppingTableHeadCells: HeadCell[] = [
    {
        id: `date`,
        numeric: false,
        disablePadding: false,
        align: `left`,
        label: `Date`,
        sx: { width: 105 },
    },
    {
        id: `store`,
        numeric: false,
        disablePadding: false,
        label: `Description`,
        colSpan: 2,
    },
    {
        id: `cashback`,
        numeric: false,
        disablePadding: false,
        align: `right`,
        label: `Cash Back`,
        sx: { width: 135 },
        editable: `cashBackHeader`,
    },
    {
        id: `status`,
        numeric: false,
        disablePadding: false,
        align: `center`,
        label: `Status`,
        sx: { "& span": { marginRight: `12px !important` }, width: 120 },
    },
    {
        id: `popup`,
        numeric: false,
        disablePadding: false,
        align: `left`,
        label: ``,
        sx: { width: 70 },
    },
];

export const shoppingTableSatuses: { name: string; value: string }[] = [
    {
        name: `All Statuses`,
        value: `all`,
    },
    { name: `Earned`, value: `earned` },
    { name: `Pending`, value: `pending` },
    { name: `Ineligible`, value: `ineligible` },
];
